// extracted by mini-css-extract-plugin
module.exports = {"root":"InputFocus_root__xBqvi","focused":"InputFocus_focused__2ZXd1"};